import { configureStore } from "@reduxjs/toolkit";
import TestReducer from "./features/testSlice";
import GlobalSelectsReducer from "./features/globalSelectsSlice";
import AuthReducer from "./features/authSlice";
import assignmentsReducer from "../pages/warehouse/warehouseManageAssignments/store/assignmentsSlice";
import dashboardReducer from "../redux/features/dashboardSlice";
// import paymentsTrackerReducer from "../pages/payments/payments-tracker/store/paymentsTrackerSlice";
import paymentsTrackerReducer from "../pages/payments/payments-tracker/store/slices/paymentsTrackerSlice";

const store = configureStore({
	reducer: {
		auth: AuthReducer,
		globalSelects: GlobalSelectsReducer,
		test: TestReducer,
		assignments: assignmentsReducer,
		dashboard: dashboardReducer,
		paymentsTracker: paymentsTrackerReducer,
	},
});

export default store;
